import { graphql } from '../../../graphql/generated';

export const CANCEL_ORDER_INVOICE_MUTATION = graphql(`
  mutation CancelOrderInvoice($orderId: ID!) {
    cancelOrderInvoice(orderId: $orderId) {
      id
    }
  }
`);
